const Icon = ({ icon }) => (
  <div className="rounded-lg bg-gradient-to-br from-white/20 to-white/7 max-w-fit p-[1px] mb-6">
    <div className="relative flex p-3 bg-black rounded-lg max-w-fit">
      <div
        className="bg-gradient-to-b from-[#D1AAD7] to-[#BBDEF2] w-6 h-6 bg-no-repeat bg-center bg-contain"
        style={{
          // @ts-ignore
          '-webkit-mask-image': `url(/static/images/icons/parakeet/transparent/${icon}.svg)`,
          '-webkit-mask-repeat': 'no-repeat',
          '-webkit-mask-position': 'center'
        }}
      />
    </div>
  </div>
);

export default Icon;
